import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomerBillingCustomerModel } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer.model';
import { FiToggleSwitchSliderColorClass } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.component';

@Component({
    selector: 'fi-customer-billing-customer-edit-usage-information',
    templateUrl: './customer-billing-customer-edit-usage-information.component.html',
    styleUrls: ['./customer-billing-customer-edit-usage-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-edit-usage-information' },
    standalone: false,
})
export class CustomerBillingCustomerEditUsageInformationComponent {
    @Input() customer: CustomerBillingCustomerModel;
    protected readonly FiToggleSwitchSliderColorClass = FiToggleSwitchSliderColorClass;
}
